module.exports = {
    /*=========================================================
       *          设置本地存储数据
       * @param key   键名
       * @param value 键值
       * @param from  来源 0: android 1: ios
    ========================================================*/
    setLocalData:function(key, value, from)
    {
        value = typeof(value) == "string" ? value:JSON.stringify(value);
        window.localStorage.setItem(key, value);
    },

    /*============================================
    函数功能:       获取本地存储数据
    传入参数:         key:键值
    =============================================*/
    getLocalData:function(key)
    {
        var storage=window.localStorage;
        if( storage.getItem(key) )
        {
            // 如果获取的值是数组或对象,则返回json对象
            if( storage.getItem(key).indexOf('[') != -1 || storage.getItem(key).indexOf('{') != -1 )
            {
                return JSON.parse(storage.getItem(key));
            }else{
                return storage[key].trim();
            }
        }
        return null;
    },

    /*============================================
    函数功能:       清除本地存储数据
    传入参数:         key:键值
    =============================================*/
    removeLocalData:function(key)
    {
        window.localStorage.removeItem(key);
    },

    /*============================================
    函数功能:       清空本地存储数据
    =============================================*/
    clearLocalData:function ()
    {
        window.localStorage.clear();
    }

};
